<template>
	<el-footer class="footer" height="23rem">
		<div class="foot">
			<div class="foot-left">
				<p class="foot-p1">
					<span>联系方式</span>
					<a href="https://yzy.homeplus.cn/about" target="_blank">关于我们</a>
				</p>
				<p class="foot-p2"></p>
				<p class="foot-p3">深圳市南山区大冲国际中心4楼</p>
				<div class="foot-p4">
					友情链接：
					<a href="http://www.worldunion.com.cn/" target="_blank">世联行</a>
					<!-- <a href="https://www.homeplus.cn/" target="_blank">世联红璞</a> -->
				</div>
				<p class="foot-p5"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备20061891号</a></p>
			</div>
			<div class="foot-right">
				<div class="code-cont">
					<p>悠租云企微</p>
					<img src="http://image.homeplus.cn/cms/f81ea9bad72145f18f5a02828742f096.webp" />
				</div>
				<div class="code-cont">
					<p>悠租云APP</p>
					<img src="http://image.homeplus.cn/cms/ffbf6c64ed8a4f979f50c8345671aa8e.webp" />
				</div>
				<div class="code-cont">
					<p>悠租云公众号</p>
					<img src="http://image.homeplus.cn/cms/d53e849419fc40a1bf147c6596dde741.webp" />
				</div>
			</div>
		</div>
		<!-- <div class="footer-copyr">Copyright (c) 2018 yozuyun.com</div> -->
	</el-footer>
</template>
<script>
export default {
	name: "y-footer",
	data: function() {
		return {}
	},
	props: [],
	methods: {},
	created: function() {}
}
</script>
<style lang="scss" scoped>
.footer {
	@media screen and (max-width: 1024px) {
		display: none;
	}
	background: #3a3b3e;
	.foot {
		display: flex;
		width: 114rem;
		margin: 0 auto;
		padding: 3.5rem 0 1rem;
		justify-content: space-between;
	}
	.footer-c {
		display: flex;
		align-items: center;
		width: 114rem;
		margin: 0 auto;
		padding: 3.5rem 0 1rem;
		@media screen and (max-width: 1024px) {
			width: 100%;
		}
		div {
			display: flex;
			flex-direction: column;
			flex: 1;
			text-align: center;
			height: 14.6rem;
		}
		p {
			font-size: 1.6rem;
			color: #ddd;
			margin-bottom: 1.5rem;
			@media screen and (max-width: 1024px) {
				font-size: 1.2rem;
				white-space: nowrap;
			}
		}
		a {
			display: block;
			color: #838489;
			text-align: left;
			padding-left: 10.2rem;
			margin-bottom: 0.3rem;
			@media screen and (max-width: 1024px) {
				font-size: 1.2rem;
				white-space: nowrap;
				padding-left: 0;
				text-align: center;
			}
		}
		img {
			margin: 0 auto;
			width: 11rem;
			height: 11rem;
			@media screen and (max-width: 1024px) {
				width: 8rem;
				height: 8rem;
			}
		}
	}
}
.footer-copyr {
	text-align: center;
	font-size: 1.2rem;
	color: #515258;
	padding: 1rem 0;
}
.foot-left {
	display: inline-block;
	vertical-align: middle;
	font-size: 14px;
}
.foot-p1 {
	margin-bottom: 12px;
}
.foot-p1 span {
	margin-right: 80px;
}
.foot-p1 a,
.foot-p1 span {
	font-size: 16px;
	color: #ddd;
	transition: color 0.3s linear;
}
.foot-p1 a:hover,
.foot-p4 a:hover {
	color: #fff;
}
.foot-p2 {
	color: #84858a;
	margin-bottom: 10px;
}
.foot-p3 {
	color: #838489;
	margin-bottom: 10px;
}
.foot-p4 {
	color: #838489;
	margin-bottom: 10px;
}
.foot-p4 a,
.foot-p5 a {
	color: #838489;
	margin-right: 10px;
	transition: color 0.3s linear;
}
.foot-right {
	display: flex;
	vertical-align: top;
	padding-right: 20px;
}
.foot-right .code-cont{
	padding-left: 65px;
}
.foot-right p {
	font-size: 16px;
	color: #ddd;
	margin-bottom: 15px;
	text-align: center;
}
.foot-right img {
	width: 102px;
	height: 102px;
}
</style>
